import { AdvancedSearchError } from './types';
import { t, type I18nLocale } from '@ardoq/i18n';

const getErrorVerb = (
  searchError: AdvancedSearchError | null,
  i18nLocale: I18nLocale
): string | null => {
  if (searchError === AdvancedSearchError.EXPORT) {
    return t(
      i18nLocale,
      'search:advancedSearchError.verb.exporting',
      'exporting'
    );
  }
  if (searchError === AdvancedSearchError.QUERY) {
    return t(
      i18nLocale,
      'search:advancedSearchError.verb.searching',
      'searching'
    );
  }
  return null;
};

const AdvancedSearchErrorMessage = ({
  searchError,
  ruleErrorMessages = [],
  i18nLocale,
}: {
  searchError: AdvancedSearchError | null;
  ruleErrorMessages?: string[];
  i18nLocale: I18nLocale;
}) => {
  const errorVerb = getErrorVerb(searchError, i18nLocale);
  return (
    <div className="search-error">
      {(ruleErrorMessages.length || null) && (
        <>
          <p>
            {t(
              i18nLocale,
              'search:advancedSearchError.updateQueryErrors',
              { verb: errorVerb ?? '' },
              'Update the following query errors before {{verb}}:'
            )}
          </p>
          <ul>
            {ruleErrorMessages.map((ruleErrorMessage, index) => (
              <li key={index}>{ruleErrorMessage}</li>
            ))}
          </ul>
        </>
      )}
      {!ruleErrorMessages.length && errorVerb && (
        <>
          <p>
            {t(
              i18nLocale,
              'search:advancedSearchError.errorOccurred',
              { verb: errorVerb },
              'An error occurred while {{verb}}. Please verify that your query is valid.'
            )}
          </p>
          <p>
            {t(
              i18nLocale,
              'search:advancedSearchError.notified',
              'We have been notified and are sorry about the inconvenience.'
            )}
          </p>
          <p>
            {t(
              i18nLocale,
              'search:advancedSearchError.contactSupport',
              'If the error persists, please contact support.'
            )}
          </p>
        </>
      )}
    </div>
  );
};

export { AdvancedSearchErrorMessage };
